import { Component, OnInit } from '@angular/core';
import {environment} from '../../../environments/environment';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.css']
})
export class CarouselComponent implements OnInit {
  cloudBasePath: string;
  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) { }
  
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    this.getRootScopeData();
    this.cloudBasePath = environment.cloudBasePath;  }

}
